function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "microphone_podcast_audio",
  "data-name": "microphone, podcast, audio",
  d: "M8,9V6a4,4,0,1,1,8,0V9A4,4,0,0,1,8,9ZM21,9a1,1,0,0,0-2,0A7,7,0,0,1,5,9,1,1,0,1,0,3,9a9.011,9.011,0,0,0,8,8.941V20H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H13V17.941A9.011,9.011,0,0,0,21,9Z",
  transform: "translate(-3 -2)"
});

var SvgAudioIcon = function SvgAudioIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudioIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio-icon.df3e84c2.svg";
export { ForwardRef as ReactComponent };